import { denormalize, normalize, schema } from "normalizr";

export const normalizeEntity = (datasources) => {
	const isArray = datasources instanceof Array;
	const dataset = isArray ? "storeBranches" : "storeBranch";
	const storeEntity = new schema.Entity("store");
	const storeBranchEntity = new schema.Entity(
		dataset,
		{
			store: storeEntity,
		}
	);
	const result = normalize(
		datasources, 
		isArray ? [storeBranchEntity] : storeBranchEntity
	);
	
	return result.entities;
}

export const denormalizeEntity = (datasources) => {
	const isArray = datasources.storeBranches;
	const dataset = isArray ? "storeBranches" : "storeBranch";
	const storeEntity = new schema.Entity(dataset)
	const entities = isArray ? datasources.storeBranches : datasources.store;

	return denormalize(
		{ [dataset]: isArray ? Object.keys(entities) : Object.keys(entities).toString() }, 
		{ [dataset]: isArray ? [storeEntity] : storeEntity }, 
		{ [dataset]: entities }
	);
}